import React from 'react';
import { CircularProgress, Paper } from '@material-ui/core';

/**
 * Custom OverlayLoading component that fixes the fade -> alpha deprecation warning
 * This replaces the default OverlayLoading component from material-table
 * Uses rgba directly instead of fade/alpha to avoid deprecation warnings
 */
const MaterialTableOverlayLoading = () => {
  return (
    <Paper
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 11,
      }}
    >
      <CircularProgress />
    </Paper>
  );
};

export default MaterialTableOverlayLoading;
